import { Alert, Snackbar } from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setClearToasterStatusMessage } from "../../Redux/reportSlice";

const Toaster = () => {
  let dispatcher = useDispatch();
  let { open, msg, severity } = useSelector(
    (state) => state.report.toasterStatusMsg
  );

  // useEffect(() => {
  //   if (toasterStatusMsg !== null) {
  //     setOpen(true);
  //   }
  // }, [toasterStatusMsg]);

  const handleClose = (event, reason) => {
    dispatcher(setClearToasterStatusMessage());
    // setOpen(false);
  };
  return (
    <div>
      <Snackbar
        open={open}
        autoHideDuration={3000}
        onClose={handleClose}
        message={msg}
        severity={severity}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {msg}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default Toaster;
